import { useState } from "react";
import { media } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { MediaManager } from "./MediaManager";
import { ImagePlus, X } from "lucide-react";

export const ImageField = ({ value, onChange, label, testid }) => {
  const [open, setOpen] = useState(false);
  return (
    <div>
      {label && <div className="text-[11px] font-mono uppercase tracking-widest text-slate-400 mb-1.5">{label}</div>}
      <div className="flex items-center gap-3">
        <div className="w-20 h-20 rounded-lg border border-white/10 overflow-hidden bg-black/40 shrink-0 flex items-center justify-center">
          {value ? <img src={media(value)} alt="" className="w-full h-full object-cover" /> : <ImagePlus size={20} className="text-slate-600" />}
        </div>
        <div className="flex flex-col gap-2">
          <Button type="button" size="sm" variant="outline" onClick={() => setOpen(true)} data-testid={testid}>Browse / Upload</Button>
          {value && (
            <button type="button" onClick={() => onChange("")} className="text-[11px] text-slate-500 hover:text-rose-400 flex items-center gap-1">
              <X size={11} /> Remove
            </button>
          )}
        </div>
      </div>
      <MediaManager open={open} onOpenChange={setOpen} onSelect={onChange} />
    </div>
  );
};
